import * as React from 'react';

import Modal from './Modal';
import Button from './Button';

export default class SubModal extends Modal {
  closeModal = () => this.setState({ opened: false });
  render() {
    const { children, width, buttonText, classes, style = {} } = this.props;
    return this.isOpened() ? (
      <div className='modal modal-sub'>
        <div
          className={`inner ${classes && classes}`}
          style={{
            width: width + '%',
            ...style,
            flexDirection: 'column',
            minWidth: '350px',
            minHeight: '250px',
          }}
        >
          <div>{children}</div>
          <Button classes='button pointer' onClick={this.props.onClose}>
            {buttonText}
          </Button>
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/theme/SubModal.js